export enum ENotificationChannel {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  BOTH = 'BOTH',
}

export interface INotificationChannelFlags {
  isSmsEnabled: boolean;
  isWhatsappEnabled: boolean;
}

export const notificationChannelToFlags = (
  channel: ENotificationChannel | string | null | undefined,
): INotificationChannelFlags => ({
  isSmsEnabled: channel === ENotificationChannel.SMS || channel === ENotificationChannel.BOTH,
  isWhatsappEnabled:
    channel === ENotificationChannel.WHATSAPP || channel === ENotificationChannel.BOTH,
});

export const flagsToNotificationChannel = ({
  isSmsEnabled,
  isWhatsappEnabled,
}: INotificationChannelFlags): ENotificationChannel => {
  if (isSmsEnabled && isWhatsappEnabled) {
    return ENotificationChannel.BOTH;
  }
  if (isWhatsappEnabled) {
    return ENotificationChannel.WHATSAPP;
  }

  return ENotificationChannel.SMS;
};

// Product delegates are validated against EXCLUSIVE_CHOICES server-side, so BOTH is a 400 there.
export const flagsToExclusiveNotificationChannel = ({
  isWhatsappEnabled,
}: INotificationChannelFlags): ENotificationChannel =>
  isWhatsappEnabled ? ENotificationChannel.WHATSAPP : ENotificationChannel.SMS;
